// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"2a72ad23","291":"e95b5279","315":"00b8f905","330":"abd892db","434":"ae3fecc2","497":"6e043ad9","678":"72aefaa5"}[chunkId] + ".chunk.js";
};